module.exports = __webpack_public_path__ + "img/exe_pdf_2.4bd838de.png";